import * as type from "../types";

const initialReport ={
    cykl: 2,
    email: [],
    nazwa: "",
    nazwa_pliku: "",
    raport_id: 0,
    typ: "",
    typ_id: 0,
    warunki: "",
    wybor: 1,
    wybor_dane: 13853,
};

const initialState = {
    availableReports: [],
    selectedReport: initialReport,
    keywordsList: [],
    pendingList: [],
    automaticReportList: [],
    fileId: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case type.SET_REPORTS:
            return {
                ...state,
                availableReports: action.value
            };
        case type.SELECT_REPORT:
            return {
                ...state,
                selectedReport: state.availableReports.find(report => report.typ_id === action.value)
            };
        case type.SET_KEYWORDS_LIST:
            return {
                ...state,
                keywordsList: action.value
            };
        case type.SET_PENDING_LIST:
            return {
                ...state,
                pendingList: action.value
            };
        case type.SET_AUTOMATIC_REPORT_LIST:
            return {
                ...state,
                automaticReportList: action.value
            };
        case type.SET_FILE_ID:
            return {
                ...state,
                fileId: action.value
            };
        default:
            return state;
    }
};
